import React from 'react';
import _ from 'lodash';

import List from '@mui/material/List';

import { useCurrentTracklog } from 'ff/debrief/hooks';
import { useGetAllTracklogsQuery } from 'ff/debrief/features/TracklogApi';
import { PAGE_SIZE } from 'ff/debrief/utils';
import TracklogListPage from './TracklogListPage';
import GhostItem from './GhostItem';
import RedirectToShared from 'ff/debrief/router/links/RedirectToShared';

interface Props {
    startTimestamp: number;
    endTimestamp: number;
    fuzzySearchTerm: string;
}

const TracklogList: React.FC<Props> = props => {
    const q = useGetAllTracklogsQuery({
        page: 0,
        startTimestamp: props.startTimestamp,
        endTimestamp: props.endTimestamp,
        fuzzySearchTerm: props.fuzzySearchTerm,
    });
    const fullListQuery = useGetAllTracklogsQuery({
        page: 0,
    });
    const t = useCurrentTracklog({ autoSelect: true });

    const totalPages = React.useMemo(() => {
        const totalItems = q.data?.totalTracklogs;
        return totalItems && Math.ceil(totalItems / PAGE_SIZE);
    }, [q.data?.totalTracklogs]);

    const isEmptyList = fullListQuery.data?.totalTracklogs === 0;

    if (q.isLoading) {
        return (
            <List sx={{ padding: '0 4px 4px' }}>
                {_.range(PAGE_SIZE).map(idx => (
                    <GhostItem key={idx} />
                ))}
            </List>
        );
    } else if (isEmptyList) {
        return <RedirectToShared />;
    } else {
        return (
            <List sx={{ padding: '0 4px 4px' }} dense>
                {_.range(totalPages).map((__, idx) => (
                    <TracklogListPage
                        startTimestamp={props.startTimestamp}
                        endTimestamp={props.endTimestamp}
                        fuzzySearchTerm={props.fuzzySearchTerm}
                        key={idx}
                        page={idx}
                    />
                ))}
            </List>
        );
    }
};

export default TracklogList;
